import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { Button, Modal } from 'antd';
import {QRCodeSVG} from 'qrcode.react';

// import { endpoint, Post, FAQList } from "./API";
import cn from "classnames";
import styles from "./InterviewQA.module.scss";


const endpoint = `https://us-central1-draperu-talenter.cloudfunctions.net`;
const endpoint2 = `http://127.0.0.1:5001/draperu-talenter/us-central1`


async function PostFunc(url) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  };
  const response = await fetch(url, requestOptions);
  const data = await response.json();
  return data;
}


const FAQList = [
  { key: "q0", q: "" },
  { key: "q1", q: "How many years of experience do they have?" },
  {
    key: "q2",
    q: "Can you provide an overview of their professional background and experience?",
  },
  { key: "q3", q: "What specific skills or expertise do they possess?" },
  { key: "q4", q: "Where is their current company?" },
  { key: "q5", q: "What is their current position?" },
  { key: "q6", q: "How many jobs did they have before?" },
  { key: "q7", q: "Please list all positions in their past experience." }
]


const ItemQ = ({ message }) => (
  <div className={styles.content_box3}>
    <h2 className={styles.message}>
      <p
        dangerouslySetInnerHTML={{ __html: message.replace(/\n/g, "<br />") }}
      />
    </h2>
  </div>
);
const ItemA = ({ message }) => (
  <div className={styles.content_box4}>
    <h2 className={styles.message}>
      <p
        dangerouslySetInnerHTML={{ __html: message.replace(/\n/g, "<br />") }}
      />
    </h2>
  </div>
);

function tryParseJson(str) {
  try {
    if (typeof str === "object") return str;
    return JSON.parse(str);
  } catch (e) {
    return null;
  }
  return null;
}

export default function InterviewQA(props) {
  let { userId } = useParams();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const messagesEndRef = useRef(null);
  const [question, setQuestion] = React.useState();
  const [messages, setMessages] = React.useState([]);
  const [currentFAQKey, setCurrentFAQKey] = React.useState("q0");
  const [fullName, setFullName] = React.useState(null);
  const [imgUrl, setImgUrl] = React.useState(null);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // retrieve user info in useEffect hook
  useEffect(() => {
    const fetchData = async () => {
      try {
        const json = await PostFunc(`${endpoint}/userInfo?id=${userId}`);

        // const { email, linkedin, github, calendly } = json.data;
        const email = json.data.email;
        console.log(json.data.linkedin);
        console.log(json.data.github);
        const linkedinData = tryParseJson(json.data.linkedin);
        console.log(linkedinData);
        const githubData = tryParseJson(json.data.github);
        const fullName = linkedinData.fullName;
        const imgUrl = linkedinData.imgUrl;
        console.log("imgUrl", imgUrl);
        setFullName(fullName);
        setImgUrl(imgUrl);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, [userId]);

  const updateInputQuestion = (evt) => {
    const val = evt.target.value;
    setQuestion(val);
  };

  const scrollToBottom = () => {
    setTimeout(() => {
      messagesEndRef?.current?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };
  const doAsk = async (q = null) => {
    const qq = q ? q : question;
    if (!qq) return;

    // setStatusMessage('processing.....');
    const m = [...messages, { type: "q", message: qq }];
    setMessages(m);
    scrollToBottom();

    const json = await PostFunc(`${endpoint}/qa?id=${userId}&q=${qq}`);
    // setStatusMessage('');
    setMessages([...m, { type: "a", message: json.answer }]);

    scrollToBottom();
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      doAsk();
      setQuestion("");
    }
  };

  const doFAQ = (e) => {
    let key = e.target.value;
    let faqItem = FAQList.filter(function (item) {
      return item.key === key;
    })[0];
    if (faqItem) {
      doAsk(faqItem.q);
    }
  };

  const showMagicLink = (e) => {

    const link = `https://draperu-talenter.web.app/Interview/${userId}`
    navigator.clipboard.writeText(link).then(function (x) {
      showModal();
    });
  }

  return (
    <div className={cn(styles.root, "interview-qa")}>
      <div className={styles.flex_col}>
        <div className={styles.flex_col__cell}>
          <h1 className={styles.title}>Ask
            <span style={{ color: 'lightseagreen', marginLeft: 12 }}>{fullName}</span>
          </h1>
        </div>

        <div className={styles.flex_row}>
          <div className={styles.flex_row__cell}>
            <div className={styles.content_box1}>
              <div className={styles.flex_col1}>
                <div className={styles.flex_col1__cell}>
                  <div
                    style={{
                      "--src": `url(${imgUrl})`,
                    }}
                    className={styles.image}
                  />
                </div>
                <div className={styles.flex_col1__cell1}>
                  <div className={styles.flex_col2}>
                    <h3 className={styles.subtitle}>{fullName}</h3>
                    { false && <QRCodeSVG style={{ margin: '24px 12px 24px 0px' }} value={`https://draperu-talenter.web.app/Interview/${userId}`} /> }
                    <h5 className={styles.highlights}></h5>
                    <h4 className={styles.highlights1}>
                      
                    </h4>
                    <div className={styles.flex_col2__cell}>
                      <button
                        style={{
                          "--src": `url(${require("assets/4113fa164478c27777b67a00435db3ee.png")})`,
                          marginRight: 12,
                        }}
                        className={styles.btn}
                      >
                        <div className={styles.flex_row1}>
                          <div className={styles.flex_row1__cell}>
                            <span className={styles.btn__text}>
                              See Full Bio
                            </span>
                          </div>
                          <div className={styles.flex_row1__spacer} />
                          <div className={styles.flex_row1__cell1}>
                            <img
                              src={require("assets/e657827ff9160a5c3091d8258706800d.png")}
                              alt="alt text"
                              className={styles.btn__icon}
                            />
                          </div>
                        </div>
                      </button>
                      <button
                        style={{
                          "--src": `url(${require("assets/4113fa164478c27777b67a00435db3ee.png")})`,
                        }}
                        onClick={showMagicLink}
                        className={styles.btn2}
                      >
                        <div className={styles.flex_row1}>
                          <div className={styles.flex_row1__cell}>
                            <span className={styles.btn__text}>Magic Link</span>
                          </div>
                          <div className={styles.flex_row1__spacer} />
                          <div className={styles.flex_row1__cell1}>
                            <img
                              src={require("assets/link.png")}
                              alt="alt text"
                              className={styles.btn__icon}
                            />
                          </div>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.flex_row__spacer} />
          <div className={styles.flex_row__cell1}>
            <div className={styles.flex_col3}>
              <div className={styles.flex_col3__cell}>
                <div className={styles.content_box6}>
                  <div className={styles.flex_row2}>
                    <div className={styles.flex_row2__cell1}>
                      <h2 className={styles.medium_title}>
                        What do you want to know about me?
                      </h2>
                    </div>
                    <div className={styles.flex_row2__cell}>
                      <span className={styles.medium_title}>(FAQ:</span>
                      <select
                        className={styles.faq}
                        id="lang"
                        onChange={doFAQ}
                        value={currentFAQKey}
                      >
                        {FAQList.map((faq, index) => {
                          return <option value={`${faq.key}`}>{faq.q}</option>;
                        })}
                      </select>
                      <span className={styles.medium_title}>)</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.content_box5}>
                <div className={styles.messageContainer}>
                  <div className={styles.messageArea}>
                    {messages.map((m, i) => {
                      if (m.type === "q") return <ItemQ message={m.message} />;
                      else if (m.type === "s")
                        return <ItemQ message={m.message} />;
                      else return <ItemA message={m.message} />;
                    })}
                    <div
                      ref={messagesEndRef}
                      style={{ float: "left", clear: "both" }}
                    ></div>
                  </div>
                </div>
              </div>

              <div className={styles.flex_col3__cell1}>
                <div className={styles.content_box2}>
                  <div className={styles.flex_row3}>
                    <h2 className={styles.medium_title11_box}>
                      <input
                        className={styles.medium_title11}
                        type={"text"}
                        placeholder={`What would you like to know about the candidate?`}
                        onFocus={() => setQuestion("")}
                        onKeyDown={handleKeyDown}
                        value={question}
                        onChange={(evt) => updateInputQuestion(evt)}
                      />
                    </h2>
                    <div
                      className={styles.flex_row3__cell}
                      onClick={() => doAsk()}
                    >
                      <img
                        src={require("assets/af21ce4a75abab5a2cde21d0495ae15d.png")}
                        alt="alt text"
                        className={styles.askButton}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal title="Magic Link" open={isModalOpen} onOk={handleOk} cancelButtonProps={{ style: { display: 'none' } }}>
        <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
        <QRCodeSVG size={256} style={{ margin: 24, textAlign: 'center' }} value={`https://draperu-talenter.web.app/Interview/${userId}`} />                    
          <div className={styles.magiclink}>
            <a href={`https://draperu-talenter.web.app/Interview/${userId}`}>
              <span>{`https://draperu-talenter.web.app/Interview/${userId}`}</span>
            </a>
        </div>
        </div>
        <p>Copied to Clipboard!</p>
      </Modal>
    </div>
  );
}
